export const formatPrice = (price) => `₹${price.toLocaleString('en-IN')}`;
export const calcDiscount = (price, mrp) => Math.round((1 - price / mrp) * 100);
export const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
export const formatDateTime = (dateStr) => new Date(dateStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
export const truncate = (str, len = 60) => str.length > len ? str.substring(0, len) + '…' : str;
export const generateOrderId = () => `CH${Date.now().toString().slice(-8)}`;
export const calcGrowth = (current, previous) =>
  previous === 0 ? 100 : Math.round(((current - previous) / previous) * 100);

// Returns a Tailwind colour class string for product badge labels
export const getBadgeClass = (badge = '') => {
  const b = badge.toLowerCase();
  if (b.includes('new'))      return 'bg-blue-500/90 text-white';
  if (b.includes('sale'))     return 'bg-emerald-500/90 text-white';
  if (b.includes('hot') || b.includes('trending')) return 'bg-orange-500/90 text-white';
  if (b.includes('limited'))  return 'bg-red-500/90 text-white';
  return 'bg-gold-500/90 text-temple-900';
};
